import { useCallback } from "react";
import { useDispatch } from 'react-redux';
import ReactPixel from 'react-facebook-pixel';
import { useHistory } from "react-router-dom";

import { setStoreRoute, updateStoreHistory, resetTabBar } from "../actions/index";
import { resetNCState } from "../components/library/nav-control/redux/actions/index";

//  Store Route Management
const useRoute = () => {
  const dispatch = useDispatch();
  const globalHistory = useHistory();

  const goTo = useCallback( to => {

    // NAV-CONTROL (MODULE)
    dispatch(resetNCState());

    // BREADCRUMB
    globalHistory.push(to);
    dispatch(updateStoreHistory(to));

    // Save Last Visited Page
    localStorage.setItem('LVP', to);

    // TABBAR // TODO LIST V3 - IN PROGRESS / NOT FINISHED
    dispatch(resetTabBar());

    //PIXEL FACEBOOK
    ReactPixel.pageView();
    ReactPixel.track(`ViewContent`, { url: to });

  }, [dispatch, globalHistory])

  const getLastLocation = () => {
    return globalHistory.location.pathname;
  }

  const store = { goTo, getLastLocation };
  setTimeout(() => { dispatch(setStoreRoute(store)) }, 100);
  return null;
};

export default useRoute;
